import { Box, Card, CardContent, Chip, Divider, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { dateformat, formatNumber } from "../../functions/misc";
import { BsBlockquoteLeft } from "react-icons/bs";

type Props = {
    lastestReportData: any,
    taxReports: any[],
    onReportClick: (reportId: any) => void
}
const TaxRiskReportList = ({ lastestReportData, taxReports, onReportClick }: Props) => {
    console.log(lastestReportData);
    return (
        <Card sx={{ borderRadius: 1 }}>
            <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
                <Typography variant="subtitle1" sx={{ m: 2, mb: 3 }}><BsBlockquoteLeft className="me-2" />{'Monthly Tax Risk Reports'}</Typography>

                {lastestReportData &&
                    <Box sx={{ borderRadius: '8px', border: '1px solid  #DCDFE4', m: 2 }}>
                        <Stack direction="row" spacing={2} sx={{ justifyContent: "space-around" }} divider={<Divider orientation="vertical" flexItem sx={{ m: 1 }} />}>
                            <div>
                                <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085' }} >{'CURRENT RISK LEVEL'}</Typography>
                                <Typography variant="body1" sx={{ mx: 2, mb: 1, textTransform: 'uppercase' }} >{lastestReportData?.RiskIndicators?.OverallRisk ? lastestReportData?.RiskIndicators?.OverallRisk : 'N/A'}</Typography>
                            </div>
                            <div>
                                <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085', textTransform: 'uppercase' }} >{'est. fed liability'}</Typography>
                                <Typography variant="body1" sx={{ mx: 2, mb: 1, }} >{lastestReportData?.TotalLiability?.Amount ? `$${formatNumber(lastestReportData?.TotalLiability?.Amount)}` : 'N/A'}</Typography>
                            </div>
                        </Stack>
                    </Box>
                }
                <Table size="small" sx={{ m: 2, border: '1px solid  #DCDFE4', width: '95%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                Report Date
                            </TableCell>
                            <TableCell align="center">
                                Risk Level
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(taxReports && taxReports.length > 0) ?
                            <>
                                {taxReports.map((report: any) => {
                                    return (
                                        <TableRow key={report.Id}>
                                            <TableCell align="center">
                                                <span className="letsdolater-taxprep" onClick={() => onReportClick(report.Id)}>
                                                    {dateformat(report.ReportDate)}
                                                </span>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Tooltip title={report.OverallRiskDescription}>
                                                    <Chip label={report.OverallRisk}
                                                        sx={{
                                                            ...(report.OverallRisk === 'Low' && { backgroundColor: '#F0FDFA', color: '#134E48' }),
                                                            ...(report.OverallRisk === 'Medium' && { backgroundColor: '#FFB400', color: '#134E48' }),
                                                            ...(report.OverallRisk === 'High' && { backgroundColor: '#FEE4E2', color: '#80231C' })
                                                        }} />
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </> :
                            <TableRow>
                                <TableCell colSpan={2}>{'No reports found'}</TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}

export default TaxRiskReportList;